import styled, { css } from "styled-components";
import { CheckboxWrapper } from "@template/components/Checkbox/styles.ts";
import { P } from "@template/components/typography/styles";
import { PopupBtn } from "../Popup/styles";
import { IInputProps } from "../Input";
import { Inline } from "../Input/styles";

export const FormContainer = styled.div`
  width: 100%;
  min-width: 100%;
  height: 100%;
  max-width: 450px;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 48px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 48px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    gap: 36px;
  }
`;

export const FormHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormHeadingTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${P} {
    color: ${({ theme }) => theme.colors.default[600]};
  }
`;

export const Form = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex-wrap: wrap;
  align-items: start;
`;

export const InputLabel = styled.p<{
  $labelPosition?: IInputProps["labelPosition"];
}>`
  color: ${({ theme }) => theme.colors.default[900]};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  cursor: default;
  white-space: nowrap;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: clip;
  display: flex;
  gap: 1px;
  align-items: center;
  ${({ $labelPosition }) => {
    switch ($labelPosition) {
      case "inside-top":
        return css`
          color: ${({ theme }) => theme.colors.default[400]};
          padding: 10px 14px 0 14px;
          margin-bottom: -8px;
        `;
      case "inside":
        return css`
          color: ${({ theme }) => theme.colors.default[400]};
          padding: 0 0 0 14px;
          margin-right: -8px;
        `;
      default:
        return css``;
    }
  }}
`;

export const RequiredStar = styled.span`
  color: ${({ theme }) => theme.colors.primary.default};
  font-weight: 600;
`;

export const SearchInput = styled.div`
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: flex-start;
  ${PopupBtn} {
    width: fit-content;
    min-width: 180px;
  }
`;

export const FormInputsContainer = styled.div`
  gap: 24px;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  width: 100%;

  ${({ theme }) => theme.breakpoints.sm.query} {
    display: flex;
    flex-direction: column;
  }

  ${CheckboxWrapper} {
    grid-column: span 12;
  }
`;

export const FormInputWrapper = styled.div`
  height: fit-content;
  max-height: max-content;

  ${PopupBtn} {
    min-width: 136px;
  }

  ${Inline} {
    min-width: 136px;
  }
`;

export const LightChild = styled.div`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 550;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.default[400]};
`;

export const FormWrapper = styled.div<{ $simple?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $simple }) =>
    $simple &&
    css`
      ${FormContainer} {
        padding: 0;
        max-width: revert;
        background: revert;
        border-radius: revert;
      }
    `}
`;

export const Error = styled.p`
  color: ${({ theme }) => theme.colors.secondary.default};
  background: ${({ theme }) => theme.colors.secondary[100]};
  padding: 12px;
  border-radius: 8px;
`;

export const Divider = styled.div`
  grid-column: span 12;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  > p {
    color: ${({ theme }) => theme.colors.primary.default};
    font-weight: 550;
    font-size: 17px;
  }

  > span {
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.colors.default[200]};
  }
`;
